import React, { useEffect } from "react";
import detectEthereumProvider from "@metamask/detect-provider";
import { ethers } from "ethers"; // Import ethers

const WalletConnect = ({ account, setAccount, setProvider }) => {
  // Automatické připojení při načtení stránky, pokud je MetaMask už připojen
  useEffect(() => {
    const tryAutoConnect = async () => {
      try {
        const ethProvider = await detectEthereumProvider({ mustBeMetaMask: true });
        if (ethProvider) {
          // Zkontrolujeme, jestli už je účet připojen
          const accounts = await ethProvider.request({ method: "eth_accounts" });
          if (accounts.length > 0) {
            console.log("Auto-connecting to MetaMask, account found:", accounts[0]);
            const browserProvider = new ethers.BrowserProvider(ethProvider); // Použijeme BrowserProvider
            setProvider(browserProvider);
            setAccount(accounts[0]);
          } else {
            console.log("No account connected, waiting for manual connection.");
          }

          // Posluchače událostí MetaMasku
          ethProvider.on("accountsChanged", (newAccounts) => {
            if (newAccounts.length > 0) {
              console.log("Account changed:", newAccounts[0]);
              setAccount(newAccounts[0]);
            } else {
              console.log("All accounts disconnected.");
              setProvider(null);
              setAccount(null);
            }
          });

          ethProvider.on("chainChanged", () => {
            window.location.reload(); // Reload při změně sítě
          });

          ethProvider.on("disconnect", () => {
            console.log("MetaMask disconnected.");
            setProvider(null);
            setAccount(null);
          });

          // Cleanup posluchačů při unmountu
          return () => {
            ethProvider.removeAllListeners("accountsChanged");
            ethProvider.removeAllListeners("chainChanged");
            ethProvider.removeAllListeners("disconnect");
          };
        } else {
          console.error("No MetaMask provider detected");
        }
      } catch (error) {
        console.error("Error during auto-connect:", error);
      }
    };

    tryAutoConnect();
  }, [setAccount, setProvider]);

  const connectWallet = async () => {
    try {
      console.log("Checking for Ethereum provider...");
      const ethProvider = await detectEthereumProvider({ mustBeMetaMask: true });
      if (ethProvider) {
        console.log("MetaMask detected:", ethProvider);
        const browserProvider = new ethers.BrowserProvider(ethProvider); // Použijeme BrowserProvider
        setProvider(browserProvider);
        const accounts = await ethProvider.request({ method: "eth_requestAccounts" });
        setAccount(accounts[0]);
        console.log("Connected account:", accounts[0]);
      } else {
        console.error("No MetaMask provider detected");
        alert("Please install MetaMask or ensure it is enabled!");
      }
    } catch (error) {
      console.error("Error connecting to MetaMask:", error);
      alert("Failed to connect to MetaMask. Check console for details.");
    }
  };

  const disconnectWallet = () => {
    setProvider(null);
    setAccount(null);
    console.log("Disconnected account");
    alert("Disconnected from the app. Note: MetaMask may still be connected. To fully disconnect, use MetaMask settings.");
  };

  return (
    <div>
      {account ? (
        <>
          <span>
            {account.slice(0, 6)}...{account.slice(-4)}
          </span>
          <button onClick={disconnectWallet}>Disconnect</button>
        </>
      ) : (
        <button onClick={connectWallet}>Connect MetaMask</button>
      )}
    </div>
  );
};

export default WalletConnect;